import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Peopels — Greater London's trusted local Helper marketplace" },
      { name: "description", content: "Peopels makes hiring local help simple, fair and trusted across every Greater London postcode." },
      { property: "og:title", content: "About Peopels" },
      { property: "og:description", content: "Our mission to make hiring local help simple, fair and trusted." },
      { property: "og:url", content: "/about" },
    ],
    links: [{ rel: "canonical", href: "/about" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          url: "/about",
          mainEntity: { "@type": "Organization", name: "Peopels", url: "/", areaServed: { "@type": "AdministrativeArea", name: "Greater London" } },
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold">About Peopels</h1>
        <p className="mt-4 text-lg text-muted-foreground">We're building Greater London's most trusted way to hire local Helpers for everyday tasks. Fair to Helpers, simple for Customers, safe for everyone.</p>
      </main>
      <Footer />
    </div>
  );
}
